import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Cancelled from './Components/Cancelled/Cancelled';
import TimedOut from './Components/Cancelled/TimedOut';
import Pending from './Components/Cancelled/Pending';
import Failed from './Components/Cancelled/Failed';
import Success from './Components/Cancelled/Success';
import DepositMain from './Components/Deposit/DepositMain';

function App() {


  return (
    <div className="App">
      <Routes>
        <Route path="/txn-pg" element={<DepositMain />} />
        <Route path="/cancel" element={<Cancelled />} />
        <Route path="/timed-out" element={<TimedOut />} />
        <Route path="/pending-confirmation" element={<Pending />} />
        <Route path="/failed" element={<Failed />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </div>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter basename='/transaction/payer'>
      <App />
    </BrowserRouter>
  );
}

export default AppWrapper;
